import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    mergeStudents(ctx, { originId, targetId }) {
      return new Promise((resolve, reject) => {
        axios
          .post('students/merge', { originId, targetId })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProfiles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('students/profiles', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStudents(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('students', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStudent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStudentProfile(ctx, { id, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${id}/profile`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStudentSessions(ctx, { id, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${id}/sessions`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStudentCourses(ctx, { id, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${id}/courses`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStudentDocuments(ctx, { id, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${id}/documents`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    uploadStudentDocument(ctx, { studentId, documentId, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`students/${studentId}/documents/${documentId}/upload`, formData, {
            headers: {
              'content-type': 'multipart/form-data',
            },
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    downloadStudentDocument(ctx, { studentId, documentId, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${studentId}/documents/${documentId}/upload`, { params: queryParams, responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    documentStudentDocumentPreview(ctx, { studentId, documentId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`students/${studentId}/documents/${documentId}/embed`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    downloadStudentDocumentProof(ctx, { studentId, documentId, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${studentId}/documents/${documentId}/proof`, { params: queryParams, responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    previewStudentDocument(ctx, { studentId, documentId, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`students/${studentId}/documents/${documentId}/preview`, { params: queryParams, responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createStudentDocument(ctx, { studentId, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`students/${studentId}/documents`, payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteStudentDocument(ctx, { studentId, documentId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`students/${studentId}/documents/${documentId}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addStudent(ctx, studentData) {
      return new Promise((resolve, reject) => {
        axios
          .post('students', studentData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateStudent(ctx, { id, studentData }) {
      // Sanitize the request body before sending it the server to prevent strict validation from killing the request
      delete studentData.id;
      delete studentData.createdAt;
      delete studentData.updatedAt;

      return new Promise((resolve, reject) => {
        axios
          .patch(`/students/${id}`, studentData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateStudentProfile(ctx, { id, profileData }) {
      // Sanitize the request body before sending it the server to prevent strict validation from killing the request
      delete profileData.id;
      delete profileData.createdAt;
      delete profileData.updatedAt;

      return new Promise((resolve, reject) => {
        axios
          .patch(`/students/${id}/profile`, profileData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
